import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../constants/dataAids';
import getStyles from './getStyles';
import ProductListItem from '../../../layouts/shop1/ProductListItem';
import * as Metrics from '../utils/trackMetric';
import * as MetricEvents from '../../../constants/metrics';

export function SimilarProducts(props) {
  const styles = getStyles(props);
  const { similarProducts } = props;

  useEffect(() => {
    Metrics.track(MetricEvents.SIMILAR_PRODUCTS_IMPRESSION);
  }, []);

  return (
    <UX2.Element.Block group='Group'>
      <UX2.Element.Heading.Product
        data-aid={ dataAids.SIMILAR_PRODUCT_RENDERED }
        children={ props.translate('products.similarProductsTitle') }
        style={ styles.similarProducts }
      />
      <UX2.Component.Grid data-aid={ dataAids.PRODUCT_LIST_RENDERED } xs={ 2 } md={ 4 }>
        { similarProducts.slice(0, 4).map(product => {
          return (
            <UX2.Component.Grid.Cell key={ product.slug } style={{ marginBottom: 'large' }}>
              <ProductListItem
                product={ product }
                productsPerRow={ 4 }
                renderMode={ props.renderMode }
                galleryShowBorder={ props.galleryShowBorder }
                imageCropMethod={ props.imageCropMethod }
                imageShape={ props.galleryImageShape }
                isRatingShown={ false }
                metrics={{ click: MetricEvents.SIMILAR_PRODUCTS_PRODUCT_CLICK }}
                useBruce={ props.useBruce }
              />
            </UX2.Component.Grid.Cell>
          );
        }) }
      </UX2.Component.Grid>
    </UX2.Element.Block>
  );
}

SimilarProducts.propTypes = {
  renderMode: PropTypes.string,
  translate: PropTypes.func,
  similarProducts: PropTypes.array,
  galleryShowBorder: PropTypes.bool,
  imageCropMethod: PropTypes.string,
  galleryImageShape: PropTypes.string,
  useBruce: PropTypes.bool
};

export default SimilarProducts;
